import { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { observer } from 'mobx-react-lite';
import { LoadingScreen } from 'src/components/loading-screen';
import { useStores } from 'src/models';
import { PATH_PAGE } from 'src/routes/paths';

type GuestGuardProps = {
  children: ReactNode;
};

function GuestGuard({ children }: GuestGuardProps) {
  const { authStore } = useStores();
  const { isInitialized, isAuthenticated } = authStore;
  const location = useLocation();

  if (!isInitialized) {
    return <LoadingScreen />;
  }

  if (isAuthenticated) {
    const state = location.state as Record<string, unknown> | null;
    const rawFrom = state?.from;
    const from =
      typeof rawFrom === 'string' && rawFrom.startsWith('/') && !rawFrom.startsWith('//')
        ? rawFrom
        : PATH_PAGE.home;
    return <Navigate to={from} replace />;
  }

  return <>{children}</>;
}

export default observer(GuestGuard);
